// extracted by mini-css-extract-plugin
export default {"Title":"ExtraInfo_Title__QZ33a","Container":"ExtraInfo_Container__98oie","BoxLeft":"ExtraInfo_BoxLeft__RW+9t","BoxRight":"ExtraInfo_BoxRight__0VtL5"};